package org.hs_soft.runmynesto.domain.model.home.options

enum class LanguageEnum(
    val displayName: String,
    val value: String,
) {
    German(
        displayName = "German",
        value = "de-DE",
    ),
    English(
        displayName = "English",
        value = "en-GB",
    ),
    French(
        displayName = "French",
        value = "fr-FR",
    ),
    Italian(
        displayName = "Italian",
        value = "it-IT",
    ),
    Polish(
        displayName = "Polish",
        value = "pl-PL",
    ),
    Russian(
        displayName = "Russian",
        value = "ru-RU",
    ),
    Portuguese(
        displayName = "Portuguese",
        value = "pt-PT",
    );

    companion object {
        fun fromDisplayName(displayName: String): LanguageEnum? =
            entries.firstOrNull { it.displayName == displayName }

        fun getIntValue(value: LanguageEnum): Int {
            return when (value) {
                English -> return 1
                German -> return 2
                French -> return 3
                Italian -> return 4
                Portuguese -> return 7
                else -> return 1
            }
        }
    }
}